import { HubApiMethods } from '../../constants/HubApiMethods';
import { HubApiError} from '../../domains/valueObject/SwitchUserProgressResponses';
import { HubJsonRpcRequest } from '../../api/HubJsonRpcRequest';
import { LinkAuthMethodOut } from '../../domains/ports/out/LinkAuthMethodOut';
import { CurrentUser } from '../../general/modules/user/currentUser';
import { LinkAuthMethodError } from '../../domains/valueObject/Errors/LinkAuthMethodError';
import { Localization } from '../../localization/localization';
import { AuthMethodAlreadyLinkedError } from '../../domains/valueObject/Errors/AuthMethodAlreadyLinkedError';
import { AuthMethod } from "../../account-window/parts/auth-method";

type LinkAuthMethodRequest = {
    suid: string,
    token: string,
    authMethod: string,
    credentials: object,
    isBigReward: boolean
}

type LinkAuthMethodResponse = 1 | HubApiError;

export class LinkAuthMethod implements LinkAuthMethodOut {
    public async linkAuthMethod(
        authMethod: string,
        credentials: object,
        isBigReward: boolean
    ): Promise<true | Error> {
        try {
            let hubApiMethod:string;
            switch (authMethod) {
                case AuthMethod.EMAIL:
                    hubApiMethod = HubApiMethods.LINK_AUTH_METHOD_EMAIL;
                    break;
                case AuthMethod.FB:
                    hubApiMethod = HubApiMethods.LINK_AUTH_METHOD_FB;
                    break;
                case AuthMethod.GOOGLE:
                    hubApiMethod = HubApiMethods.LINK_AUTH_METHOD_GOOGLE;
                    break;
                case AuthMethod.APPLE_ID:
                    hubApiMethod = HubApiMethods.LINK_AUTH_METHOD_APPLE_ID;
                    break;
                default:
                    throw new Error('Unknown auth method');
            }
            const linkMethodResponse: LinkAuthMethodResponse = await HubJsonRpcRequest.makeRequest<
                LinkAuthMethodResponse,
                LinkAuthMethodRequest
            >(
                hubApiMethod,
                {
                    authMethod,
                    credentials,
                    isBigReward,
                    suid: CurrentUser.getInstance().getSuid()
                        .toString(),
                    token: CurrentUser.getInstance().getAuthToken()
                },
                window.app.deviceIdentifier
            );

            if (linkMethodResponse === 1) {
                return true;
            }

            if (linkMethodResponse?.error) {
                console.error(linkMethodResponse.error);
                if (linkMethodResponse.error.code === 5004) {
                    return new AuthMethodAlreadyLinkedError(linkMethodResponse.error.message);
                }
                // TODO make different error types and messages for different errors
                return new LinkAuthMethodError(Localization._n('common_error'));
            }

            console.error('Unexpected response', linkMethodResponse);

            return new LinkAuthMethodError(Localization._n('common_error'));
        } catch (exception) {
            console.error(exception);
            window.Sentry.captureException(exception);
            return new LinkAuthMethodError(Localization._n('common_error'));
        }
    }
}
